function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_1247)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26 30H30V29H26V30ZM5 18.2V20H27V18.2C27 16.8 27.8 15.6 29 15.2V10.8C29 9.80002 28.2 8.90002 27.1 8.90002H4.9C3.8 9.00002 3 9.80002 3 10.9V15.3C4.2 15.6 5 16.8 5 18.2ZM5 23H27V21H5V23ZM2 30H6V29H2V30ZM31.4 16.3C31 15.9 30.5 15.7 30 15.7C29.5 15.7 29 15.9 28.6 16.3C28.2 16.7 28 17.2 28 17.7V23.5C28 23.8 27.8 24.1 27.4 24.1H4.6C4.3 24 4 23.7 4 23.4V17.7C4 17 3.6 16.3 3 16C1.5 15.3 0 16.3 0 17.7V28H32V17.7C32 17.2 31.8 16.7 31.4 16.3Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34 4H4V6H34V4Z",
  fill: "#860935"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.7 4.2L31.8 0.3C31.4 -0.1 30.7 -0.1 30.3 0.3C29.9 0.7 29.9 1.4 30.3 1.8L33.4 5L30.3 8.2C29.9 8.6 29.9 9.3 30.3 9.7C30.5 9.9 30.8 10 31.1 10C31.4 10 31.7 9.9 31.9 9.7L35.8 5.8C36.1 5.3 36.1 4.7 35.7 4.2Z",
  fill: "#860935"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_1247"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 30,
  fill: "white"
})));

function SvgSofaLength({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzNiAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzFfMTI0NykiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI2IDMwSDMwVjI5SDI2VjMwWk01IDE4LjJWMjBIMjdWMTguMkMyNyAxNi44IDI3LjggMTUuNiAyOSAxNS4yVjEwLjhDMjkgOS44MDAwMiAyOC4yIDguOTAwMDIgMjcuMSA4LjkwMDAySDQuOUMzLjggOS4wMDAwMiAzIDkuODAwMDIgMyAxMC45VjE1LjNDNC4yIDE1LjYgNSAxNi44IDUgMTguMlpNNSAyM0gyN1YyMUg1VjIzWk0yIDMwSDZWMjlIMlYzMFpNMzEuNCAxNi4zQzMxIDE1LjkgMzAuNSAxNS43IDMwIDE1LjdDMjkuNSAxNS43IDI5IDE1LjkgMjguNiAxNi4zQzI4LjIgMTYuNyAyOCAxNy4yIDI4IDE3LjdWMjMuNUMyOCAyMy44IDI3LjggMjQuMSAyNy40IDI0LjFINC42QzQuMyAyNCA0IDIzLjcgNCAyMy40VjE3LjdDNCAxNyAzLjYgMTYuMyAzIDE2QzEuNSAxNS4zIDAgMTYuMyAwIDE3LjdWMjhIMzJWMTcuN0MzMiAxNy4yIDMxLjggMTYuNyAzMS40IDE2LjNaIiBmaWxsPSIjQjNCM0IzIi8+CjxwYXRoIGQ9Ik0zNCA0SDRWNkgzNFY0WiIgZmlsbD0iIzg2MDkzNSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM1LjcgNC4yTDMxLjggMC4zQzMxLjQgLTAuMSAzMC43IC0wLjEgMzAuMyAwLjNDMjkuOSAwLjcgMjkuOSAxLjQgMzAuMyAxLjhMMzMuNCA1TDMwLjMgOC4yQzI5LjkgOC42IDI5LjkgOS4zIDMwLjMgOS43QzMwLjUgOS45IDMwLjggMTAgMzEuMSAxMEMzMS40IDEwIDMxLjcgOS45IDMxLjkgOS43TDM1LjggNS44QzM2LjEgNS4zIDM2LjEgNC43IDM1LjcgNC4yWiIgZmlsbD0iIzg2MDkzNSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzFfMTI0NyI+CjxyZWN0IHdpZHRoPSIzNiIgaGVpZ2h0PSIzMCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgSofaLength as ReactComponent };